module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/care-provider-792962b1f7763e739fb4a97da232a097.svg";